export const DepartmentsURL =
  'https://boards-api.greenhouse.io/v1/boards/tia/departments?content=true'
